module.exports = __webpack_public_path__ + "static/media/sign.784356e4.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/sign.PNG
// module id = 540
// module chunks = 0